import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

const Team = (props) => {
  const [teamDetails, setTeamDetails] = useState([]);

  const getTeamDetails = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Teams/getTeamDetails",
      );
      if (response.data.teamDetails) {
        let teamDetailsArray = JSON.parse(response.data.teamDetails);
        teamDetailsArray = teamDetailsArray.sort((a, b) => a.order - b.order);
        setTeamDetails(teamDetailsArray);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  }, []);

  useEffect(() => {
    getTeamDetails();
  }, [getTeamDetails, props.variable]);

  const language = localStorage.getItem("language");

  return (
    <section>
      <IconButton
        className="close-icon-team"
        onClick={() => {
          props.onTeamPopupClose();
        }}
      >
        <CloseIcon />
      </IconButton>
      <div className="dialog-header-row-team">
        <span className="dialog-header">
          {language === "en" && "Development Team"}
          {language === "sl" && "අපේ කණ්ඩායම"}
          {language === "tm" && "எங்கள் அணி"}
        </span>
      </div>
      <div className="d-flex flex-column align-items-center team-container">
        {teamDetails.map((member, index) => (
          <div
            className="d-flex flex-column align-items-start team-div"
            key={member.id || index}
          >
            {member.isImage && (
              <img
                className="team-image"
                src={member.imageUrl}
                alt="location"
              />
            )}
            {!member.isImage && (
              <>
                <div className="d-flex flex-row align-items-center">
                  {member.memberImageUrl && (
                    <img
                      className="team-member-image"
                      src={member.memberImageUrl}
                      alt="location"
                    />
                  )}
                  <div className="d-flex flex-column align-items-start">
                    <span className="team-member-name">{member.name}</span>
                    <span className="team-member-position">
                      {member.position}
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
